import { getToken, getTokenHeader } from '../../../screen/auth/action';
import { axios } from '../../../utils/settings';
import { getCompanySuppliersUrl, getSearchProductsUrl, searchCompanyUrl } from '../url';

export const fetchSkuFilterAction = async (searchIndex, queryData) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${getSearchProductsUrl()}?search_index=${searchIndex}&filter=true`,
        queryData,
        { ...getTokenHeader(token) },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// export const getCompanySuppliersAction = async (
//   module = 'default',
//   params = {},
// ) => {
//   // Always resolve with dummy data
//   return Promise.resolve({
//     "message": "Suppliers fetched successfully",
//     "error": false,
//     "data": {
//       "suppliers_list": [
//         {
//           "id": 288311,
//           "name": "Welspun Shield TMT",
//           "logo": "https://finalcompanylogos.s3.ap-south-1.amazonaws.com/bcm/tmt/Welspun+Shield.png",
//           "secondary_scheme_banners": null,
//           "po_config": {
//             "as_seller": {
//               "required": true,
//               "approval_required": true
//             }
//           },
//           "dp_config": {
//             "as_seller": {
//               "required": true,
//               "approval_required": true
//             }
//           },
//           "cash_discount_config": {
//             "type": "percent",
//             "label": "Flat 5%",
//             "value": 0.05,
//             "is_applicable": false
//           },
//           "price_visibility": true,
//           "is_secondary_supplier_required": true,
//           "entity_enabled": true,
//           "entity_info": [
//             {
//               "esi_id": 1646401,
//               "external_system_code": "1775551037.348445",
//               "status": "ACTIVE",
//               "role": "DEALER",
//               "role_status": "ACTIVE"
//             },
//             {
//               "esi_id": 1646454,
//               "external_system_code": "1775738099.072744",
//               "status": "INACTIVE",
//               "role": "DEALER",
//               "role_status": "ACTIVE"
//             },
//             {
//               "esi_id": 1646504,
//               "external_system_code": "1775738099.072744",
//               "status": "PENDING",
//               "role": "SUBDEALER",
//               "role_status": "PENDING"
//             }
//           ]
//         },
//         {
//           "id": 293613,
//           "name": "BHAWANI MOULDERS",
//           "logo": "https://finalcompanylogos.s3.ap-south-1.amazonaws.com/bcm/erw/Garvity+ERW.png",
//           "secondary_scheme_banners": null,
//           "po_config": {
//             "as_seller": {
//               "required": true,
//               "approval_required": true
//             }
//           },
//           "dp_config": {
//             "as_seller": {
//               "required": true,
//               "approval_required": true
//             }
//           },
//           "cash_discount_config": {
//             "type": "percent",
//             "label": "Flat 5%",
//             "value": 0.05,
//             "is_applicable": false
//           },
//           "price_visibility": true,
//           "is_secondary_supplier_required": true,
//           "entity_enabled": false,
//           "entity_info": [
//             {
//               "esi_id": 1646401,
//               "external_system_code": "1775551037.348445",
//               "status": "ACTIVE",
//               "role": "DISTRIBUTOR",
//               "role_status": "ACTIVE"
//             }
//           ]
//         },
//         {
//           "id": 294967,
//           "name": "DP White Products",
//           "logo": "https://finalcompanylogos.s3.ap-south-1.amazonaws.com/bcm/paint/DP_white+logo+2-1.png",
//           "secondary_scheme_banners": [
//             "https://mcsecondaryscheme.s3.us-east-1.amazonaws.com/paintandhardware/DPwhite/Novemebrscheme.png",
//             "https://mcsecondaryscheme.s3.amazonaws.com/paintandhardware/DPwhite/WhatsApp+Image+2024-10-04+at+10.41.27-1.png"
//           ],
//           "po_config": {
//             "as_seller": {
//               "required": false,
//               "approval_required": false
//             }
//           },
//           "dp_config": {
//             "as_seller": {
//               "required": true,
//               "approval_required": true
//             }
//           },
//           "cash_discount_config": {
//             "type": "percent",
//             "label": "Flat 5%",
//             "value": 0.05,
//             "is_applicable": true
//           },
//           "price_visibility": false,
//           "is_secondary_supplier_required": true,
//           "entity_enabled": false,
//           "entity_info": [
//             {
//               "esi_id": 1646401,
//               "external_system_code": "1775551037.348445",
//               "status": "ACTIVE",
//               "role": "DISTRIBUTOR",
//               "role_status": "ACTIVE"
//             },
//             {
//               "esi_id": 1646454,
//               "external_system_code": "1775738099.072744",
//               "status": "INACTIVE",
//               "role": "DEALER",
//               "role_status": "TERMINATED"
//             },
//             {
//               "esi_id": 1646504,
//               "external_system_code": "1775738099.072744",
//               "status": "PENDING",
//               "role": "SUBDEALER",
//               "role_status": "PENDING"
//             }
//           ]
//         },
//         {
//           "id": 293612,
//           "name": "GRAVITY FERROUS ERW",
//           "logo": "https://finalcompanylogos.s3.ap-south-1.amazonaws.com/bcm/erw/Garvity+ERW.png",
//           "secondary_scheme_banners": null,
//           "po_config": {
//             "as_seller": {
//               "required": true,
//               "approval_required": true
//             }
//           },
//           "dp_config": {
//             "as_seller": {
//               "required": true,
//               "approval_required": true
//             }
//           },
//           "cash_discount_config": {
//             "type": "percent",
//             "label": "Flat 5%",
//             "value": 0.05,
//             "is_applicable": false
//           },
//           "price_visibility": true,
//           "is_secondary_supplier_required": false,
//           "entity_enabled": false,
//           "entity_info": [
//             {
//               "esi_id": 1646401,
//               "external_system_code": "1775551037.348445",
//               "status": "ACTIVE",
//               "role": "DISTRIBUTOR",
//               "role_status": "ACTIVE"
//             },
//             {
//               "esi_id": 1646454,
//               "external_system_code": "1775738099.072744",
//               "status": "INACTIVE",
//               "role": "SUBDEALER",
//               "role_status": "TERMINATED"
//             }
//           ]
//         }
//       ]
//     },
//     "formatting_args": null
//   });
// };
export const searchCompanyAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        searchCompanyUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};


export const getCompanySuppliersAction = async (
  module = 'default',
  params = {},
) => {
  return new Promise(async (next) => {
    let token = await getToken();
    if (params instanceof URLSearchParams) {
      params.append('module', module);
    } else {
      params = new URLSearchParams(params);
      params.append('module', module);
    }
    await axios
      .get(getCompanySuppliersUrl(), {
        ...getTokenHeader(token),
        params,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};